import React from 'react';
import './PageHeader.css';

// Standard page header: optional eyebrow, title (+ inline extras such as a
// streak pill), subtitle and right-aligned actions.
function PageHeader({ eyebrow, title, subtitle, actions, children }) {
  return (
    <header className="page-header">
      <div className="page-header-text">
        {eyebrow && <span className="page-eyebrow">{eyebrow}</span>}
        <div className="page-title-row">
          <h1 className="page-title">{title}</h1>
          {children}
        </div>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </header>
  );
}

export default PageHeader;
